export default {
  version: 'Please select an applicable version',
  btn: {
    android: 'Android',
    ios: 'iOS',
    huawei: 'HarmonyOS',
  },

  huaweiDownloadTips: 'Huawei HarmonyOS Next Download Instructions',
  huawei: {
    title: 'Huawei HarmonyOS Next Download',
    subTitle: 'Instructions for Installing the WeMust App',
    appName: 'DroiTong',

    explanationTitleOne: '1、Install the Zhuoyitong APP',
    explanationContentOne: 'Please install "DroiTong" from the [App Market].',

    explanationTitleTwo: '2、Find the Search Application',
    explanationContentTwo: 'After installation,The "DroiTong" folder on your home screen will contain the "Search Application".',

    explanationTitleThree: '3、Install the Android APP',
    explanationContentThree: 'Click on the "Search Application" Open the installation link(<a class="link" href="{jumpUrl}" target="_blank">{link}</a>), then click to install the Android APP.',

    explanationTitleFour: '4、Select and install the WeMust apk',
    explanationContentFour: 'After the download is complete, go to [Menu] - [Downloads] - select the apk you wish to install.',
  },

  tips: 'Scan qr code to download App',
  copyRight: '澳門科技大學 版權所有',
  auth: `${new Date().getFullYear()} WeMust All Rights Reserved`,
  download_tip: {
    text1: 'Please click on the top right corner',
    text2: 'Select "Open in browser"',
  },
};
